<script>
import { h } from "vue";
import { Link } from "@inertiajs/vue3";
export default {
    name: "Tile",
    props: {
        title: String,
        subtitle: String,
        url: {
            type: String,
            defualt: null
        }
    },
    render() {
        const children = [h("div", { class: "min-w-0 flex-1" }, [h("h2", {
            class: "nl-section-title",
            innerHTML: this.title,
        }),
        h("p", {
            class: "mt-1 text-sm text-nomad-400",
            innerHTML: this.subtitle,
        }),],),]
        if (this.url) {
            children.push(h(Link, { href: this.url, class: "group inline-flex shrink-0 items-center gap-1 text-sm font-medium text-nomad-300 transition-colors hover:text-nomad-accent" }, () => [
                "See all",
                h("span", { class: "icon-arrow-right transition-transform group-hover:translate-x-0.5", "aria-hidden": "true" }),
            ]))
        }
        return h("div", { class: "mb-5 mt-12 flex w-full items-end gap-4" }, children);
    },
};
</script>
